import { Text } from 'platform-components';
import React from 'react';

import './custom-lesson-view__description.scss';

interface Props {
    text: string | null;
}

export const CustomLessonViewDescription = React.memo(({ text }: Props) => {
    if (!text) {
        return null;
    }

    return (
        <div className="custom-lesson-view__description">
            <Text size={Text.SIZE.XL} type={Text.TYPE.MARKDOWN}>
                {text}
            </Text>
        </div>
    );
});
